import { AdminGroupHierarchyNode } from "@nextiva/next-ui-wayfinder";
import axios from "axios_client";
const ADMIN_GROUPS_BASE_URL = "/admin-groups";

export const getAdminGroupsHierarchy = (): Promise<AdminGroupHierarchyNode> =>
  axios
    .get<AdminGroupHierarchyNode>(`${ADMIN_GROUPS_BASE_URL}/hierarchy`, {
      params: { includeLocationAdmins: true },
    })
    .then((res) => res.data);

// The /admin-groups/locations proxy trims the VSOS DTO to the two fields the
// location-name map needs; only these are ever present in the response.
export type CorpLocationName = Pick<CorpLocation, "locationId" | "locationName">;

// Cookie-auth backend proxy for the VSOS corp-locations endpoint; resolves
// display names for LOCATION nodes, whose AGS `name` is a numeric id. The
// backend derives the corp account from the session.
export const getCorpLocations = (): Promise<CorpLocationName[]> =>
  axios
    .get<CorpLocationName[]>(`${ADMIN_GROUPS_BASE_URL}/locations`)
    .then((res) => res.data);

export interface CorpLocation {
  accountNumber?: string | null;
  city?: string | null;
  country?: string | null;
  countryId?: string | number | null;
  defaultExtensionLength: number | null;
  defaultLocation: boolean | null;
  description?: string | null;
  location: string | null;
  locationId?: string | number | null;
  locationName?: string | null;
  locationNumber?: string | null;
  maxExtensionLength: number | null;
  minExtensionLength: number | null;
  state?: string | null;
  streetName?: string | null;
  streetNumber?: string | null;
  streetType?: string | null;
  timeZone?: string | null;
  userCount?: number | null;
  voiceEnabled?: boolean | null;
  zip?: string | null;
}